export const signedIn = 'SignedIn';
export const miscGCs = 'MISCGCs';
export const lastReviewUsername = 'last_review_username';
export const productsReviewed = 'products_reviewed';
export const shippingCountry = 'shippingCountry';
export const currency = 'currency';
export const secureUserToken = 'secure_user_token';
export const csl = 'CSL'; // current store location
export const bopsPickupInStore = 'BOPSPICKUPSTORE';
export const zipCode = 'USERPC';
export const bigTicketZipCode = 'BTZIPCODE';
export const forwardPageURL = 'FORWARDPAGE_KEY';
